import { SideCard } from '@components/side-card'
import * as React from 'react'

export const VipSideCard = (): JSX.Element => (
  <SideCard
    className="d-lg-block d-none"
    image={<img src={require('@assets/images/vip-label.png')} alt="Gastro voucher label" />}
  />
)
